"use client";

import { Button } from "@ala/core/components/button";
import { NotFound } from "@ala/core/components/not-found";
import { useTransitionRouter } from "@ala/core/transition-router";

const NotFoundPage = () => {
  const router = useTransitionRouter();

  return (
    <NotFound>
      <Button className="justify-start" variant="outline" size="md" color="contrast" onClick={() => router.push("/")}>
        Go to homepage
      </Button>
    </NotFound>
  );
};

export default NotFoundPage;
